import { create } from 'zustand';
const useIsSMSHistoryFiltersOpenStore = create()((set) => ({
    isHistoryFiltersOpen: false,
    setIsHistoryFiltersOpen: (isHistoryFiltersOpen) => set({ isHistoryFiltersOpen }),
}));
export default useIsSMSHistoryFiltersOpenStore;
